/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { ChangeDetectionStrategy, Component, Directive, ViewEncapsulation } from '@angular/core';
import { CDK_ROW_TEMPLATE, CdkHeaderRow, CdkHeaderRowDef, CdkRow, CdkRowDef, } from '@angular/cdk/table';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MatHeaderRowDef = CdkHeaderRowDef;
export const /** @type {?} */ _MatCdkRowDef = CdkRowDef;
export const /** @type {?} */ _MatHeaderRow = CdkHeaderRow;
export const /** @type {?} */ _MatRow = CdkRow;
/**
 * Header row definition for the mat-table.
 * Captures the header row's template and other header properties such as the columns to display.
 */
export class MatHeaderRowDef extends _MatHeaderRowDef {
}
MatHeaderRowDef.decorators = [
    { type: Directive, args: [{
                selector: '[matHeaderRowDef]',
                providers: [{ provide: CdkHeaderRowDef, useExisting: MatHeaderRowDef }],
                inputs: ['columns: matHeaderRowDef'],
            },] },
];
/**
 * @nocollapse
 */
MatHeaderRowDef.ctorParameters = () => [];
function MatHeaderRowDef_tsickle_Closure_declarations() {
    /** @type {?} */
    MatHeaderRowDef.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatHeaderRowDef.ctorParameters;
}
/**
 * Data row definition for the mat-table.
 * Captures the header row's template and other row properties such as the columns to display and
 * a when predicate that describes when this row should be used.
 */
export class MatRowDef extends _MatCdkRowDef {
}
MatRowDef.decorators = [
    { type: Directive, args: [{
                selector: '[matRowDef]',
                providers: [{ provide: CdkRowDef, useExisting: MatRowDef }],
                inputs: ['columns: matRowDefColumns', 'when: matRowDefWhen'],
            },] },
];
/**
 * @nocollapse
 */
MatRowDef.ctorParameters = () => [];
function MatRowDef_tsickle_Closure_declarations() {
    /** @type {?} */
    MatRowDef.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatRowDef.ctorParameters;
}
/**
 * Header template container that contains the cell outlet. Adds the right class and role.
 */
export class MatHeaderRow extends _MatHeaderRow {
}
MatHeaderRow.decorators = [
    { type: Component, args: [{selector: 'mat-header-row',
                template: CDK_ROW_TEMPLATE,
                host: {
                    'class': 'mat-header-row',
                    'role': 'row',
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                exportAs: 'matHeaderRow',
                preserveWhitespaces: false,
            },] },
];
/**
 * @nocollapse
 */
MatHeaderRow.ctorParameters = () => [];
function MatHeaderRow_tsickle_Closure_declarations() {
    /** @type {?} */
    MatHeaderRow.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatHeaderRow.ctorParameters;
}
/**
 * Data row template container that contains the cell outlet. Adds the right class and role.
 */
export class MatRow extends _MatRow {
}
MatRow.decorators = [
    { type: Component, args: [{selector: 'mat-row',
                template: CDK_ROW_TEMPLATE,
                host: {
                    'class': 'mat-row',
                    'role': 'row',
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                exportAs: 'matRow',
                preserveWhitespaces: false,
            },] },
];
/**
 * @nocollapse
 */
MatRow.ctorParameters = () => [];
function MatRow_tsickle_Closure_declarations() {
    /** @type {?} */
    MatRow.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatRow.ctorParameters;
}
//# sourceMappingURL=row.js.map